import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { BILLING_FREQUENCY } from "@/shared/domains";

type BillingFrequency =
  (typeof BILLING_FREQUENCY)[keyof typeof BILLING_FREQUENCY];

const VALID_FREQUENCIES = Object.values(
  BILLING_FREQUENCY,
) as BillingFrequency[];

interface LongevityStore {
  productSlug?: string;
  frequency?: BillingFrequency;
  setLongevityParams: (params: {
    productSlug?: string;
    frequency?: BillingFrequency;
  }) => void;
}

export const useLongevityStore = create<LongevityStore>()(
  persist(
    (set) => ({
      productSlug: undefined,
      frequency: undefined,
      setLongevityParams: (params) => set(params),
    }),
    {
      name: "longevity-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export const parseLongevityFrequency = (
  value: string | null,
): BillingFrequency | undefined => {
  const parsed = Number(value);
  return VALID_FREQUENCIES.includes(parsed as BillingFrequency)
    ? (parsed as BillingFrequency)
    : undefined;
};
